var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "k-radio-button-container",
      class: { "k-radio-button-disabled": _vm.disabled },
      on: { click: _vm.toggleCheck },
    },
    [
      _c("div", { staticClass: "tr" }, [
        _c(
          "div",
          { staticClass: "k-radio-button" },
          [
            _c("input", {
              directives: [
                {
                  name: "autofocus",
                  rawName: "v-autofocus",
                  value: _vm.autofocus,
                  expression: "autofocus",
                },
              ],
              ref: "input",
              staticClass: "k-radio-button-input",
              attrs: { id: _vm.id, type: "radio", disabled: _vm.disabled },
              domProps: {
                checked: _vm.isChecked,
                value: _vm.buttonValue !== null ? _vm.buttonValue : _vm.value,
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleCheck.apply(null, arguments)
                },
                focus: function ($event) {
                  _vm.active = true
                },
                blur: _vm.blur,
                change: _vm.update,
                keydown: _vm.keydown,
              },
            }),
            _vm.isChecked
              ? _c("KIcon", {
                  staticClass: "radio-button-icon",
                  style: [
                    { fill: _vm.$themeTokens.primary },
                    _vm.disabledStyle,
                    _vm.activeStyle,
                  ],
                  attrs: {
                    icon: "radioSelected",
                    name: "radio_button_checked",
                  },
                })
              : _c("KIcon", {
                  staticClass: "radio-button-icon",
                  style: [
                    { fill: _vm.$themeTokens.annotation },
                    _vm.disabledStyle,
                    _vm.activeStyle,
                  ],
                  attrs: {
                    icon: "radioUnselected",
                    name: "radio_button_unchecked",
                  },
                }),
          ],
          1
        ),
        _c(
          "label",
          {
            staticClass: "k-radio-button-label",
            class: { visuallyhidden: !_vm.showLabel },
            style: _vm.labelStyle,
            attrs: { dir: "auto", for: _vm.id },
            on: {
              click: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _vm.$slots.default
              ? [_vm._t("default")]
              : [
                  _c("div", { class: [_vm.truncateText] }, [
                    _vm._v(_vm._s(_vm.label)),
                  ]),
                ],
            _vm.description
              ? _c(
                  "div",
                  {
                    staticClass: "description",
                    style: [
                      {
                        color: _vm.disabled ? "" : _vm.$themeTokens.annotation,
                      },
                      _vm.disabledStyle,
                    ],
                  },
                  [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")]
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }